export const SCAN_STUCK_TIME_MIN = 2; // following Raul's recomendation, 2 minutes should be enough to consider a scan as stuck (https://wattsense.atlassian.net/browse/FE-1295?focusedCommentId=22244)

export const SCREEN_BREAKPOINTS = {
	mobile: 0,
	tablet: 769,
	deskstop: 1024,
	widescreen: 1216,
	shrinkSidebar: 1366,
	fullHD: 1408
};
